import UserAPIServiceImpl from "../../data/api/impl/user_api_service_impl";
import ChatAPIServiceImpl from "../../data/api/impl/chat_api_service_impl";
import UserRepositoryImpl from "../../data/repository/user_repository_impl";
import LocalStorageServiceImpl from "../../data/service/impl/local_storage_service_impl";
import TierAPIServiceImpl from "../../data/api/impl/tier_api_service_impl";
import TierRepositoryImpl from "../../data/repository/tier_repository_impl";
import ChatRepositoryImpl from "../../data/repository/chat_repository_impl";
import { createUserSlice } from "../state/slice/user_slice";
import { persistReducer } from "redux-persist";
import { createLoginSlice } from "../page/login/state/login_slice";
import { createOtpSlice } from "../page/otp/state/otp_slice";
import { createCreateAccountSlice } from "../page/createaccount/state/create_account_slice";
import storage from "redux-persist/lib/storage";
import { createChatSlice } from "../page/chat/state/chat_slice";
import { createChangePasswordSlice } from "../page/profile/state/change_password_slice";
import { createProfileSlice } from "../page/profile/state/profile_slice";
import { createMenuSlice } from "../components/menu/state/menu_slice";
import AddonRepositoryImpl from "../../data/repository/addon_repository_impl";
import AddonAPIServiceImpl from "../../data/api/impl/addon_api_service_imp";
import VideoCallSocketServiceImpl from "../../data/service/impl/video_call_socket_service_impl";
import VoiceCallSocketServiceImpl from "../../data/service/impl/voice_call_socket_service_impl";
import AddonSocketServiceImpl from "../../data/service/impl/addon_socket_service_impl";
import MessagingSocketServiceImpl from "../../data/service/impl/messaging_socket_service_impl";
import MediaAPIServiceImpl from "../../data/api/impl/media_api_service_impl";
import MediaRepositoryImpl from "../../data/repository/media_repository_impl";
import { createGallerySlice } from "../page/chat/state/gallery_slice";
import { createModelProfileSlice } from "../state/slice/model_profile_slice";
import AvatarAPIServiceImpl from "../../data/api/impl/avatar_api_service_impl";
import AvatarRepositoryImpl from "../../data/repository/avatar_repository_impl";
import { createChatSubsSlice } from "../page/chat/state/chat_subs_slice";
import PricingSocketServiceImpl from "../../data/service/impl/pricing_socket_service_impl";
import PaymentAPIServiceImpl from "../../data/api/impl/payment_api_service_impl";
import PaymentRepositoryImpl from "../../data/repository/payment_repository_impl";
import TrackingServiceImpl from "../../data/service/impl/tracking_service_impl";

//Services
export const userAPIService = new UserAPIServiceImpl();
export const chatAPIService = new ChatAPIServiceImpl();
export const localStorageService = new LocalStorageServiceImpl();
export const tierAPIService = new TierAPIServiceImpl();
export const addonAPIService = new AddonAPIServiceImpl();
export const mediaAPIService = new MediaAPIServiceImpl();
export const messagingSocketService = new MessagingSocketServiceImpl();
export const videoCallSocketService = new VideoCallSocketServiceImpl();
export const voiceCallSocketService = new VoiceCallSocketServiceImpl();
export const addonSocketService = new AddonSocketServiceImpl();
export const avatarAPIService = new AvatarAPIServiceImpl();
export const pricingSocketService = new PricingSocketServiceImpl();
export const paymentAPIService = new PaymentAPIServiceImpl();
export const trackingService = new TrackingServiceImpl();

//Repository
export const userRepository = new UserRepositoryImpl(userAPIService, localStorageService);
export const tierRepository = new TierRepositoryImpl(tierAPIService, localStorageService, pricingSocketService);
export const chatRepository = new ChatRepositoryImpl(
  chatAPIService,
  localStorageService,
  videoCallSocketService,
  voiceCallSocketService,
  messagingSocketService,
  trackingService,
);
export const addonRepository = new AddonRepositoryImpl(addonAPIService, addonSocketService);
export const avatarRepository = new AvatarRepositoryImpl(avatarAPIService);
export const mediaRepository = new MediaRepositoryImpl(mediaAPIService);
export const paymentRepository = new PaymentRepositoryImpl(paymentAPIService, localStorageService, pricingSocketService);

//User Slice
const userPersistConfig = {
  key: "user",
  storage,
  whiteList: ["user"],
};
export const userSlice = createUserSlice(userRepository);
export const userActions = userSlice.actions;
export const persistedUserReducer = persistReducer(userPersistConfig, userSlice.reducer);

//Menu Slice
export const menuSlice = createMenuSlice();
export const menuActions = menuSlice.actions;
export const menuReducer = menuSlice.reducer;

//Login Slice
export const loginSlice = createLoginSlice(userRepository);
export const loginActions = loginSlice.actions;
export const loginReducer = loginSlice.reducer;

//Create Account Slice
export const createAccountSlice = createCreateAccountSlice(userRepository);
export const createAccountActions = createAccountSlice.actions;
export const createAccountReducer = createAccountSlice.reducer;

//OTP Slice
export const otpSlice = createOtpSlice();
export const otpActions = otpSlice.actions;
export const otpReducer = otpSlice.reducer;

//Chat Slice
export const chatSlice = createChatSlice(chatRepository);
export const chatActions = chatSlice.actions;
export const chatReducer = chatSlice.reducer;

//Change Password
export const changePasswordSlice = createChangePasswordSlice();
export const changePasswordActions = changePasswordSlice.actions;
export const changePasswordReducer = changePasswordSlice.reducer;

//Profile Slice
export const profileSlice = createProfileSlice(userRepository, tierRepository, addonRepository, avatarRepository);
export const profileActions = profileSlice.actions;
export const profileReducer = profileSlice.reducer;

// Avatar Profile Slice
export const modelProfileSlice = createModelProfileSlice(avatarRepository);
export const modelProfileActions = modelProfileSlice.actions;
export const modelProfileReducers = modelProfileSlice.reducer;

//Gallery Slice
export const gallerySlice = createGallerySlice(mediaRepository);
export const galleryActions = gallerySlice.actions;
export const galleryReducer = gallerySlice.reducer;

//Chat subscription slice
export const chatSubsSlice = createChatSubsSlice(tierRepository, localStorageService);
export const chatSubsActions = chatSubsSlice.actions;
export const chatSubsReducer = chatSubsSlice.reducer;
